import { useLayoutEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useEmail } from '@app/api/profile/useEmail';
import { useDialogContext } from '@app/components/dialogs/DialogProvider';
import { ThemeButton } from '@shared/ui/buttons';
import { PasswordInput } from '@shared/ui/forms/inputs';
import { validateServerErrors } from '@utils/validation';

export default function EmailCheckPasswordForm({ setStep }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const { setSubtitle } = useDialogContext();
  const { sendOldEmail } = useEmail();

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm();

  async function onSubmit(formData) {
    try {
      const res = await sendOldEmail(formData);
      if (res) setStep(2);
    } catch (err) {
      validateServerErrors(setError, err);
    }
  }

  useLayoutEffect(() => {
    setSubtitle(user.email);
  }, []);

  return (
    <>
      <DialogContent>
        <PasswordInput
          label={t('password')}
          control={control}
          name="password"
          noValidation
          placeholder={t('enter_password')}
          error={errors.password}
        />
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          endIcon="chevron-right"
          loading={isSubmitting}
        >
          {t('continue')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
